import { render, staticRenderFns } from "./MemberSideBar.vue?vue&type=template&id=74e97228&"
import script from "./MemberSideBar.vue?vue&type=script&lang=js&"
export * from "./MemberSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports